import React from "react";

interface KVItem {
  label: React.ReactNode;
  value: string;
}

interface KVGridProps {
  items: KVItem[];
}

export const KVGrid: React.FC<KVGridProps> = ({ items }) => {
  return (
    <dl className="kvgrid">
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <dt>{it.label}</dt>
          <dd>{it.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
};
